var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "bg-white blocks mb-2 d-flex" }, [
      _c("div", { staticClass: "col" }, [_vm._v("\n    Job\n  ")]),
      _vm._v(" "),
      _c("div", { staticClass: "col col-padding" }, [
        _vm._v("\n    Move Date\n  ")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col" }, [_vm._v("\n    Booked Company\n  ")]),
      _vm._v(" "),
      _c("div", { staticClass: "col" }, [_vm._v("\n    Carrier\n  ")]),
      _vm._v(" "),
      _c("div", { staticClass: "col" }, [_vm._v("\n    Description\n  ")]),
      _vm._v(" "),
      _c("div", { staticClass: "col" }, [_vm._v("\n    Amount\n  ")]),
      _vm._v(" "),
      _c("div", { staticClass: "col" }, [_vm._v("\n    Type\n  ")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-686cfeaf", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-686cfeaf","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/reports/DiscountsHeader.vue
// module id = null
// module chunks = 